import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  User,
  FileText,
  History,
  Menu,
  ChevronDown,
  ChevronRight,
  Power,
  Plane,
  Building2,
  Clock ,
  Image,
  Settings,
  Signpost,
} from "lucide-react";
import "./AppLayout.css";
// ✅ IMPORT LOGOS
import BrandLogo from "../../assets/big-logo.png"; 
import IconLogo from "../../assets/big-logo.png"; 

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // State Management
  const [collapsed, setCollapsed] = useState(false);
  const [openModule, setOpenModule] = useState("STUDENT MANAGEMENT"); // Default open module
  const [openMenu, setOpenMenu] = useState(null); // Default open sub-menu

  const [currentTime, setCurrentTime] = React.useState("");

React.useEffect(() => {
  const updateTime = () => {
    const now = new Date();
    setCurrentTime(
      now.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    );
  };

  updateTime(); // initial
  const timer = setInterval(updateTime, 60000); // update every minute
  return () => clearInterval(timer);
}, []);


  // ✅ 1. Define Modules & Items
  const navModules = [
    {
      module: "STUDENT MANAGEMENT",
      items: [
        { 
          label: "Master", 
          icon: History, 
          children: [
            // { label: "Menu", path: "admin/master/menu" },
            // { label: "Sub Menu", path: "admin/master/sub-menu" },
              { label: "Define Class Names ", path: "admin/define-class-name/manage-class" },
              { label: "Regular Fee Heads ", path: "admin/define-fee-head/manage-regular-fee-heads" },
              { label: "Occasional Fee Heads ", path: "admin/define-fee-head/manage-occasional-fee-heads" },
              { label: "Regular Fee Amount ", path: "admin/define-fee-amount/manage-fee-amount" },
              { label: "Occasional Fee Amount ", path: "admin/define-fee-amount/manage-occasional-fee-amount" },
               { label: "Miscellaneous Income Heads ", path: "admin/miscellaneous-income-heads/manage-miscellaneous-income-heads" },
               { label: "Bank Account Details", path: "admin/bank-account-details/manage-bank-account-details" },
          ] 
        },
         { 
          label: "Admission of Students", 
          icon: History, 
          children: [
              { label: "Add Students Admission", path: "admin/admission-of-students/add-students-admission" },
          ] 
        },
        { 
          label: "Profile", 
          icon: History, 
          children: [
            { label: "View Profile", path: "admin/profile/manage-profile" },
            { label: "Change Password", path: "admin/profile/change-password" },
          ] 
        }
        // { label: "Manage Page", path: "admin/manage-page", icon: FileText },
        // { label: "Contact Details", path: "admin/contact-page", icon: History },
        // { label: "Slider", path: "admin/slider-page", icon: Image },

        
        // { 
        //   label: "Settings", 
        //   icon: Settings, 
        //   children: [
        //     { label: "Address", path: "/admin/address-add" },
        //     { label: "Social Meadia", path: "/admin/social-media-add" },
        //   ] 
        // },
          // { label: "Post", path: "admin/post-manage", icon: Signpost },
        // { 
        //   label: "Salary Process", 
        //   icon: User, 
        //   children: [
        //     { label: "Driver Salary", path: "/salary/driver-salary" },
        //      { label: "Prepare Salary", path: "/salary/prepare" },
        //     { label: "Confirm Salary", path: "/salary/confirm-salary" },
        //     { label: "Salary Slip", path: "/salary/salary-slip" },
        //   ] 
        // },
        // { label: "Drivers Activity", path: "/driver-login-status", icon: FileText },
        // { label: "SOS Reports", path: "/sos", icon: FileText },
        // { label: "Driver Tracking", path: "/driver-tracking", icon: Plane },
      ]
    },
    // {
    //   module: "Flight Module",
    //   items: [
    //     { label: "Flight Bookings", path: "/flights/bookings", icon: Plane },
    //     { label: "Flight Inventory", path: "/flights/inventory", icon: Plane },
    //   ]
    // },
    // {
    //   module: "Hotel Module",
    //   items: [
    //     { label: "Hotel Inventory", path: "/hotels/inventory", icon: Building2 },
    //     { label: "Hotel Bookings", path: "/hotels/bookings", icon: Building2 },
    //   ]
    // }
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");

  const handleLogout = () => {
    localStorage.clear();
     navigate("/admin");
  };

  // Toggle Top-Level Module (Driver, Flight, etc.)
  const toggleModule = (moduleName) => {
    if (collapsed) {
      setCollapsed(false);
      setOpenModule(moduleName);
    } else {
      setOpenModule(openModule === moduleName ? null : moduleName);
    }
  };

  // Toggle Inner Sub-menu (Master, Salary Process)
  // ✅ CORRECTED LOGIC: Handles expansion when collapsed
  const toggleSubmenu = (e, label, moduleName) => {
    e.stopPropagation(); // Prevent conflicts with parent clicks

    if (collapsed) {
      // If sidebar is collapsed, we must perform 3 steps:
      setCollapsed(false);       // 1. Open the sidebar
      setOpenModule(moduleName); // 2. Open the correct Module (e.g., Driver)
      setOpenMenu(label);        // 3. Open the specific Sub-menu (e.g., Master)
    } else {
      // Normal behavior: just toggle the sub-menu
      setOpenMenu(openMenu === label ? null : label);
    }
  };

  return (
    <div className={`al-layout-container ${collapsed ? "al-collapsed" : ""}`}>
      {/* ================= SIDEBAR ================= */}
      <aside className="al-sidebar">
        
        {/* LOGO HEADER */}
        <div className="al-sidebar-header">
          <div className="al-logo-container">
            {collapsed ? (
               <img src={IconLogo} alt="P" className="al-logo-icon-img" />
            ) : (
               <img src={BrandLogo} alt="Patra Travels" className="al-logo-full-img" />
            )}
          </div>
        </div>

        {/* NAVIGATION CONTENT */}
        <div className="al-sidebar-content">
          <nav className="al-nav-menu">
            
            {/* 1. Global Dashboard Link (Always Visible) */}
            <div 
              className={`al-nav-item ${isActive("/admin/dashboard") ? "al-active" : ""}`}
              onClick={() => navigate("/admin/dashboard")}
            >
              <LayoutDashboard size={20} className="al-nav-icon" />
              <span className="al-nav-label">Dashboard</span>
            </div>

            {/* 2. Loop Through Modules */}
            {navModules.map((group) => {
              const isModuleOpen = openModule === group.module;
              
              return (
                <div key={group.module} className={`al-module-wrapper ${isModuleOpen ? "al-module-open" : ""}`}>
                  
                  {/* Module Header (Clickable) */}
                  <div className="al-module-header" onClick={() => toggleModule(group.module)}>
                    <span className="al-module-title">{group.module}</span>
                    <div className="al-module-arrow">
                      {isModuleOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                    </div>
                  </div>

                  {/* Module Items Container (Animated) */}
                  <div className="al-module-items-container">
                    {group.items.map((item) => {
                      const Icon = item.icon;
                      const hasChildren = !!item.children;
                      const isSubOpen = openMenu === item.label;
                      const isItemActive = isActive(item.path);

                      return (
                        <div key={item.label} className="al-nav-group-item">
                          
                          {/* Main Nav Item */}
                          <div
                            className={`al-nav-item ${isItemActive ? "al-active" : ""} ${isSubOpen ? "al-sub-open" : ""}`}
                            onClick={(e) => 
                              hasChildren 
                                // ✅ FIXED: Passing group.module here ensures correct expansion
                                ? toggleSubmenu(e, item.label, group.module) 
                                : navigate(item.path)
                            }
                          >
                            <Icon size={20} className="al-nav-icon" />
                            <span className="al-nav-label">{item.label}</span>
                            
                            {hasChildren && (
                              <div className="al-arrow-wrapper">
                                {isSubOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                              </div>
                            )}
                          </div>

                          {/* Sub-Menu (Nested Children) */}
                          {hasChildren && (
                            <div className={`al-submenu ${isSubOpen ? "al-expanded" : ""}`}>
                              {item.children.map((sub) => (
                                <div
                                  key={sub.path}
                                  className={`al-submenu-item ${isActive(sub.path) ? "al-sub-active" : ""}`}
                                  onClick={() => navigate(sub.path)}
                                >
                                  <span className="al-dot"></span>
                                  <span>{sub.label}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </nav>
        </div>
      </aside>

      {/* ================= MAIN CONTENT ================= */}
      <div className="al-main-wrapper">
        
        {/* TOP HEADER */}
        <header className="al-topbar d-flex justify-content-between align-items-center px-3">

            {/* LEFT */}
            <div className="al-topbar-left d-flex align-items-center gap-2">
              <button className="al-toggle-btn" onClick={() => setCollapsed(!collapsed)}>
                <Menu size={22} />
              </button>

              {collapsed && (
                <img src={BrandLogo} alt="Patra" className="al-header-logo-img" />
              )}
            </div>

            {/* RIGHT */}
            <div className="al-topbar-right d-flex align-items-center gap-3">

              <div className="d-flex align-items-center gap-2 px-3 py-2 rounded-4 shadow-sm">
                
                <div className="text-center">
                  <small className="text-white fw-bold d-block" style={{ fontSize: "12px" }}>
                    CURRENT TIME
                  </small>
                  <span className="fw-bolder text-white">{currentTime}</span>
                </div>
              </div>

              {/* Divider */}
              <div className="al-divider-vertical"></div>

              {/* LOGOUT */}
              <button
                className="al-header-logout-btn"
                onClick={handleLogout}
                title="Logout"
              >
                <Power size={20} />
              </button>

            </div>
          </header>


        {/* PAGE CONTENT */}
        <main className="al-page-content">
          <div className="al-content-container">
            <Outlet />
          </div>
        </main>
      </div>
      <footer className="dashboard-footer">

© 2026 . All rights reserved. | Developed by Orisys Infotech

</footer>
    </div>
  );
};

export default AppLayout;